module.exports = RedNaoPDFImporter.default('PDFImporter/Manager/PDFManager/AnnotationManager');